import { useCustomer } from 'features/customers/hooks/useCustomer'
import { useCustomerFeatures } from 'features/customers/hooks/useCustomerFeatures'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'
import { getCustomerFeaturesData } from 'features/customers/utils/features'

export const useCustomerFeaturesData = () => {
  const customerId = useCustomerId()

  const { data: customer } = useCustomer(customerId)
  const { data: features, isLoading } = useCustomerFeatures(true, customerId)

  const planFeatures = customer?.plan?.features || {}

  const data = getCustomerFeaturesData(planFeatures, features, customer?.tier)

  return { data, features, isLoading, planName: customer?.plan?.name }
}
